<template>
  <div
    class="card-comment"
    :class="cardClass"
  >
    <div v-if="!isModalCard" class="card-comment__header">
      <h3 class="fw-normal" :class="cardTitleClass">
        {{ title }}
      </h3>
    </div>

    <div class="card-comment__body">
      <div class="card-comment__body-head">
        <div class="flex">
          <svgicon
            class="card-comment__avatar mr-8"
            icon="user-avatar"
            :width="iconSize"
          />

          <p class="mr-30">
            {{ fullName(comment.user.name, comment.user.surname) }}
          </p>
        </div>

        <p>
          {{ comment.created_at | date('datetime') }}
        </p>
        <VButton
          v-if="collapsible && showAccordion"
          size="xs"
          color="transparent"
          class="ml-auto"
          :icon="{ name: 'arrow', dir: isExpanded ? '0' : '180' }"
          @click.native="isExpanded = !isExpanded"
        />
      </div>

      <h4 v-if="isModalCard && comment.consignment" class="mb-8">
        Партия № {{ comment.consignment.sort }}
      </h4>

      <div ref="message"
         class="card-comment__message text-content"
         :class="{
            'card-comment__message--collapsed': collapsible && !isExpanded
          }"
         :style="messageStyle"
          v-html="sanitizeMessage" />
    </div>
  </div>
</template>

<script>
import { fullName, sanitizeHtml } from '@/utils/string'
import VButton from '@/components/simple/button/VButton.vue'

export default {
  components: { VButton },
  props: {
    comment: {
      type: Object,
      default: () => {}
    },
    isModalCard: {
      type: Boolean,
      required: false,
      default: false
    },
    collapsible: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isExpanded: false,
    showAccordion: true,
    collapsedHeight: 0,
    fullHeight: 0
  }),
  mounted () {
    if (!this.collapsible) return

    this.$nextTick(this.calculateHeights)
  },
  computed: {
    messageStyle () {
      if (!this.collapsible) return {}

      return {
        maxHeight: this.isExpanded
          ? `${this.fullHeight}px`
          : `${this.collapsedHeight}px`
      }
    },
    cardClass () {
      const classes = []
      if (this.isModalCard) classes.push('card-comment--modal')

      switch (this.comment.type) {
        case 2: classes.push('card-comment--bg-red')
      }

      return classes
    },
    title () {
      switch (this.comment.type) {
        case 2: return 'Рекламация'
        default: return 'Комментарий'
      }
    },
    cardTitleClass () {
      switch (this.comment.type) {
        case 2: return 'color--red'
        default: return 'color--green'
      }
    },
    iconSize () {
      return this.isModalCard ? '20' : '24'
    },
    sanitizeMessage () {
      return sanitizeHtml(this.comment.comment)
    }
  },
  methods: {
    fullName,
    calculateHeights () {
      const el = this.$refs.message
      if (!el) return

      // сбрасываем ограничения, чтобы корректно измерить высоту
      el.style.maxHeight = 'none'

      this.fullHeight = el.scrollHeight

      const lineHeight = parseFloat(getComputedStyle(el).lineHeight)
      this.collapsedHeight = lineHeight * 2

      this.showAccordion = this.fullHeight > this.collapsedHeight + 1

      // если текста мало — всегда раскрыто
      if (!this.showAccordion) {
        this.isExpanded = true
      }
    }
  }
}
</script>
